// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-3f8e123a] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.button-vue[data-v-3f8e123a] {
  --button-size: var(--default-clickable-area);
  --button-radius: var(--border-radius-element, calc(var(--button-size) / 2));
  --button-padding: clamp(var(--default-grid-baseline), var(--button-radius), calc(var(--default-grid-baseline) * 4));
  position: relative;
  width: fit-content;
  overflow: hidden;
  border: 0;
  padding: 0;
  font-size: var(--default-font-size);
  font-weight: bold;
  min-height: var(--button-size);
  min-width: var(--button-size);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: var(--button-radius);
  transition-property: color, border-color, background-color;
  transition-duration: 0.1s;
  transition-timing-function: linear;
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light);
}
.button-vue--size-small[data-v-3f8e123a] {
  --button-size: var(--clickable-area-small, 24px);
  --button-radius: var(--border-radius);
}
.button-vue--size-large[data-v-3f8e123a] {
  --button-size: var(--clickable-area-large, 48px);
}
.button-vue *[data-v-3f8e123a],
.button-vue span[data-v-3f8e123a] {
  cursor: pointer;
}
.button-vue[data-v-3f8e123a]:focus {
  outline: none;
}
.button-vue[data-v-3f8e123a]:disabled {
  cursor: default;
  opacity: 0.5;
  filter: saturate(0.7);
}
.button-vue:disabled *[data-v-3f8e123a] {
  cursor: default;
}
.button-vue[data-v-3f8e123a]:hover:not(:disabled) {
  background-color: var(--color-primary-element-light-hover);
}
.button-vue[data-v-3f8e123a]:active {
  background-color: var(--color-primary-element-light);
}
.button-vue__wrapper[data-v-3f8e123a] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.button-vue--end .button-vue__wrapper[data-v-3f8e123a] {
  justify-content: end;
}
.button-vue--start .button-vue__wrapper[data-v-3f8e123a] {
  justify-content: start;
}
.button-vue--reverse .button-vue__wrapper[data-v-3f8e123a] {
  flex-direction: row-reverse;
}
.button-vue--reverse.button-vue--icon-and-text[data-v-3f8e123a] {
  padding-inline: var(--button-padding) var(--default-grid-baseline);
}
.button-vue__icon[data-v-3f8e123a] {
  height: var(--button-size);
  width: var(--button-size);
  min-height: var(--button-size);
  min-width: var(--button-size);
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-vue--size-small .button-vue__icon[data-v-3f8e123a] > * {
  max-height: 16px;
  max-width: 16px;
}
.button-vue--size-small .button-vue__icon[data-v-3f8e123a] svg {
  height: 16px;
  width: 16px;
}
.button-vue__text[data-v-3f8e123a] {
  font-weight: bold;
  margin-bottom: 1px;
  padding: 2px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.button-vue--icon-only[data-v-3f8e123a] {
  line-height: 1;
  width: var(--button-size) !important;
}
.button-vue--text-only[data-v-3f8e123a] {
  padding: 0 var(--button-padding);
}
.button-vue--text-only .button-vue__text[data-v-3f8e123a] {
  margin-left: 4px;
  margin-right: 4px;
}
.button-vue--icon-and-text[data-v-3f8e123a] {
  --button-padding: min(calc(var(--default-grid-baseline) + var(--button-radius)), calc(var(--default-grid-baseline) * 4));
  padding-block: 0;
  padding-inline: var(--default-grid-baseline) var(--button-padding);
}
.button-vue--wide[data-v-3f8e123a] {
  width: 100%;
}
.button-vue[data-v-3f8e123a]:focus-visible {
  outline: 2px solid var(--color-main-text) !important;
  box-shadow: 0 0 0 4px var(--color-main-background) !important;
}
.button-vue:focus-visible.button-vue--vue-tertiary-on-primary[data-v-3f8e123a] {
  outline: 2px solid var(--color-primary-element-text);
  border-radius: var(--border-radius-element, var(--border-radius));
  background-color: transparent;
}
.button-vue--vue-primary[data-v-3f8e123a] {
  background-color: var(--color-primary-element);
  color: var(--color-primary-element-text);
}
.button-vue--vue-primary[data-v-3f8e123a]:hover:not(:disabled) {
  background-color: var(--color-primary-element-hover);
}
.button-vue--vue-primary[data-v-3f8e123a]:active {
  background-color: var(--color-primary-element);
}
.button-vue--vue-secondary[data-v-3f8e123a] {
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light);
}
.button-vue--vue-secondary[data-v-3f8e123a]:hover:not(:disabled) {
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light-hover);
}
.button-vue--vue-tertiary[data-v-3f8e123a] {
  color: var(--color-main-text);
  background-color: transparent;
}
.button-vue--vue-tertiary[data-v-3f8e123a]:hover:not(:disabled) {
  background-color: var(--color-background-hover);
}
.button-vue--vue-tertiary-no-background[data-v-3f8e123a] {
  color: var(--color-main-text);
  background-color: transparent;
}
.button-vue--vue-tertiary-no-background[data-v-3f8e123a]:hover:not(:disabled) {
  background-color: transparent;
}
.button-vue--vue-tertiary-on-primary[data-v-3f8e123a] {
  color: var(--color-primary-element-text);
  background-color: transparent;
}
.button-vue--vue-tertiary-on-primary[data-v-3f8e123a]:hover:not(:disabled) {
  background-color: transparent;
}
.button-vue--vue-success[data-v-3f8e123a] {
  background-color: var(--color-success);
  color: white;
}
.button-vue--vue-success[data-v-3f8e123a]:hover:not(:disabled) {
  background-color: var(--color-success-hover);
}
.button-vue--vue-success[data-v-3f8e123a]:active {
  background-color: var(--color-success);
}
.button-vue--vue-warning[data-v-3f8e123a] {
  background-color: var(--color-warning);
  color: white;
}
.button-vue--vue-warning[data-v-3f8e123a]:hover:not(:disabled) {
  background-color: var(--color-warning-hover);
}
.button-vue--vue-warning[data-v-3f8e123a]:active {
  background-color: var(--color-warning);
}
.button-vue--vue-error[data-v-3f8e123a] {
  background-color: var(--color-error);
  color: white;
}
.button-vue--vue-error[data-v-3f8e123a]:hover:not(:disabled) {
  background-color: var(--color-error-hover);
}
.button-vue--vue-error[data-v-3f8e123a]:active {
  background-color: var(--color-error);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcButton-DnNZaEy_.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,4CAA4C;EAC5C,2EAA2E;EAC3E,mHAAmH;EACnH,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mCAAmC;EACnC,0DAA0D;EAC1D,yBAAyB;EACzB,kCAAkC;EAClC,8CAA8C;EAC9C,oDAAoD;AACtD;AACA;EACE,gDAAgD;EAChD,qCAAqC;AACvC;AACA;EACE,gDAAgD;AAClD;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kEAAkE;AACpE;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,wHAAwH;EACxH,gBAAgB;EAChB,kEAAkE;AACpE;AACA;EACE,WAAW;AACb;AACA;EACE,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oDAAoD;EACpD,iEAAiE;EACjE,6BAA6B;AAC/B;AACA;EACE,8CAA8C;EAC9C,wCAAwC;AAC1C;AACA;EACE,oDAAoD;AACtD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;EAC9C,oDAAoD;AACtD;AACA;EACE,8CAA8C;EAC9C,0DAA0D;AAC5D;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,+CAA+C;AACjD;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,oCAAoC;AACtC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-3f8e123a] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.button-vue[data-v-3f8e123a] {\n  --button-size: var(--default-clickable-area);\n  --button-radius: var(--border-radius-element, calc(var(--button-size) / 2));\n  --button-padding: clamp(var(--default-grid-baseline), var(--button-radius), calc(var(--default-grid-baseline) * 4));\n  position: relative;\n  width: fit-content;\n  overflow: hidden;\n  border: 0;\n  padding: 0;\n  font-size: var(--default-font-size);\n  font-weight: bold;\n  min-height: var(--button-size);\n  min-width: var(--button-size);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: var(--button-radius);\n  transition-property: color, border-color, background-color;\n  transition-duration: 0.1s;\n  transition-timing-function: linear;\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light);\n}\n.button-vue--size-small[data-v-3f8e123a] {\n  --button-size: var(--clickable-area-small, 24px);\n  --button-radius: var(--border-radius);\n}\n.button-vue--size-large[data-v-3f8e123a] {\n  --button-size: var(--clickable-area-large, 48px);\n}\n.button-vue *[data-v-3f8e123a],\n.button-vue span[data-v-3f8e123a] {\n  cursor: pointer;\n}\n.button-vue[data-v-3f8e123a]:focus {\n  outline: none;\n}\n.button-vue[data-v-3f8e123a]:disabled {\n  cursor: default;\n  opacity: 0.5;\n  filter: saturate(0.7);\n}\n.button-vue:disabled *[data-v-3f8e123a] {\n  cursor: default;\n}\n.button-vue[data-v-3f8e123a]:hover:not(:disabled) {\n  background-color: var(--color-primary-element-light-hover);\n}\n.button-vue[data-v-3f8e123a]:active {\n  background-color: var(--color-primary-element-light);\n}\n.button-vue__wrapper[data-v-3f8e123a] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.button-vue--end .button-vue__wrapper[data-v-3f8e123a] {\n  justify-content: end;\n}\n.button-vue--start .button-vue__wrapper[data-v-3f8e123a] {\n  justify-content: start;\n}\n.button-vue--reverse .button-vue__wrapper[data-v-3f8e123a] {\n  flex-direction: row-reverse;\n}\n.button-vue--reverse.button-vue--icon-and-text[data-v-3f8e123a] {\n  padding-inline: var(--button-padding) var(--default-grid-baseline);\n}\n.button-vue__icon[data-v-3f8e123a] {\n  height: var(--button-size);\n  width: var(--button-size);\n  min-height: var(--button-size);\n  min-width: var(--button-size);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.button-vue--size-small .button-vue__icon[data-v-3f8e123a] > * {\n  max-height: 16px;\n  max-width: 16px;\n}\n.button-vue--size-small .button-vue__icon[data-v-3f8e123a] svg {\n  height: 16px;\n  width: 16px;\n}\n.button-vue__text[data-v-3f8e123a] {\n  font-weight: bold;\n  margin-bottom: 1px;\n  padding: 2px 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.button-vue--icon-only[data-v-3f8e123a] {\n  line-height: 1;\n  width: var(--button-size) !important;\n}\n.button-vue--text-only[data-v-3f8e123a] {\n  padding: 0 var(--button-padding);\n}\n.button-vue--text-only .button-vue__text[data-v-3f8e123a] {\n  margin-left: 4px;\n  margin-right: 4px;\n}\n.button-vue--icon-and-text[data-v-3f8e123a] {\n  --button-padding: min(calc(var(--default-grid-baseline) + var(--button-radius)), calc(var(--default-grid-baseline) * 4));\n  padding-block: 0;\n  padding-inline: var(--default-grid-baseline) var(--button-padding);\n}\n.button-vue--wide[data-v-3f8e123a] {\n  width: 100%;\n}\n.button-vue[data-v-3f8e123a]:focus-visible {\n  outline: 2px solid var(--color-main-text) !important;\n  box-shadow: 0 0 0 4px var(--color-main-background) !important;\n}\n.button-vue:focus-visible.button-vue--vue-tertiary-on-primary[data-v-3f8e123a] {\n  outline: 2px solid var(--color-primary-element-text);\n  border-radius: var(--border-radius-element, var(--border-radius));\n  background-color: transparent;\n}\n.button-vue--vue-primary[data-v-3f8e123a] {\n  background-color: var(--color-primary-element);\n  color: var(--color-primary-element-text);\n}\n.button-vue--vue-primary[data-v-3f8e123a]:hover:not(:disabled) {\n  background-color: var(--color-primary-element-hover);\n}\n.button-vue--vue-primary[data-v-3f8e123a]:active {\n  background-color: var(--color-primary-element);\n}\n.button-vue--vue-secondary[data-v-3f8e123a] {\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light);\n}\n.button-vue--vue-secondary[data-v-3f8e123a]:hover:not(:disabled) {\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light-hover);\n}\n.button-vue--vue-tertiary[data-v-3f8e123a] {\n  color: var(--color-main-text);\n  background-color: transparent;\n}\n.button-vue--vue-tertiary[data-v-3f8e123a]:hover:not(:disabled) {\n  background-color: var(--color-background-hover);\n}\n.button-vue--vue-tertiary-no-background[data-v-3f8e123a] {\n  color: var(--color-main-text);\n  background-color: transparent;\n}\n.button-vue--vue-tertiary-no-background[data-v-3f8e123a]:hover:not(:disabled) {\n  background-color: transparent;\n}\n.button-vue--vue-tertiary-on-primary[data-v-3f8e123a] {\n  color: var(--color-primary-element-text);\n  background-color: transparent;\n}\n.button-vue--vue-tertiary-on-primary[data-v-3f8e123a]:hover:not(:disabled) {\n  background-color: transparent;\n}\n.button-vue--vue-success[data-v-3f8e123a] {\n  background-color: var(--color-success);\n  color: white;\n}\n.button-vue--vue-success[data-v-3f8e123a]:hover:not(:disabled) {\n  background-color: var(--color-success-hover);\n}\n.button-vue--vue-success[data-v-3f8e123a]:active {\n  background-color: var(--color-success);\n}\n.button-vue--vue-warning[data-v-3f8e123a] {\n  background-color: var(--color-warning);\n  color: white;\n}\n.button-vue--vue-warning[data-v-3f8e123a]:hover:not(:disabled) {\n  background-color: var(--color-warning-hover);\n}\n.button-vue--vue-warning[data-v-3f8e123a]:active {\n  background-color: var(--color-warning);\n}\n.button-vue--vue-error[data-v-3f8e123a] {\n  background-color: var(--color-error);\n  color: white;\n}\n.button-vue--vue-error[data-v-3f8e123a]:hover:not(:disabled) {\n  background-color: var(--color-error-hover);\n}\n.button-vue--vue-error[data-v-3f8e123a]:active {\n  background-color: var(--color-error);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
